import React from 'react';
import QuoteSuccessScreen from './screens/success/QuoteSuccessScreen';

function QuoteSuccess() {
  return (
    <>
      <QuoteSuccessScreen />
    </>
  );
}

export default QuoteSuccess;
